<template>
  <section id="form-quote-start" class="rel quote-start-section">
    <v-container class="pa-0 ">
      <div class="mx-auto">
        <v-card 
          class="mx-auto align-items-center border-shadow-card" 
          :max-width="maxWidth"
          >
            <v-toolbar>
              <v-toolbar-title class="text-h5">
                {{ formTitle }}
              </v-toolbar-title>
            </v-toolbar>
            <v-divider class="mt-0"/>
            <v-card-subtitle v-if="formSubtitle">
              <h5>{{ formSubtitle }}</h5>
            </v-card-subtitle>
            <v-card-text>
            <v-form name="requestForm" ref="requestForm" class="contact-form">
              <v-row>
                <v-col cols="12">
                  <v-card variant="outlined" color="#999999" class="pa-3">
                    <div class="s-12 color--grey mb-1">Who is the primary insured?</div>
                    <v-btn-toggle v-model="policyHolderType" mandatory>

                      <v-btn value="adult">
                        <v-icon class="mr-2">mdi-human-handsdown</v-icon> Adult (18 or older)
                      </v-btn>
                      
                      <v-btn value="minor">
                        <v-icon class="mr-2">mdi-human-child</v-icon> Minor (under 18)
                      </v-btn>

                    </v-btn-toggle>
                  </v-card>
                </v-col>
              </v-row>
              <v-expand-transition>
                <div v-if="isChild" class="mb-5">
                  <v-alert type="info" variant="tonal" class="mt-3 mb-5">
                    Child must be at least 15 days old. Enter 0 for age if the child is less than 1 year old.
                  </v-alert>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="quotePayload.issueStateAbbreviation"
                        ref="issueStateAbbreviation"
                        :items="states"
                        :variant="inputVariant"
                        :rules="requiredRules"
                        :loading="statesPending"
                        bg-color="white"
                        item-title="name"
                        item-value="code"
                        label="Minor Resident State"
                        autocomplete="off"
                        hide-details="auto"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="quotePayload.primaryInsured.person.age"
                        :variant="inputVariant"
                        :rules="ageRulesMinor"
                        bg-color="white"
                        type="number"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        name="age"
                        label="Minor Age"
                        autocomplete="off"
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="applicationInfo.product.primaryInsured.person.name.first"
                        :variant="inputVariant"
                        type="firstName"
                        name="firstName"
                        label="Minor First Name"
                        autocomplete="off"
                        :rules="requiredRules"
                        required
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="applicationInfo.product.primaryInsured.person.name.last"
                        :variant="inputVariant"
                        type="lastName"
                        name="lastName"
                        label="Minor Last Name"
                        autocomplete="off"
                        :rules="requiredRules"
                        required
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="applicationInfo.product.primaryInsured.person.name.suffix"
                        :variant="inputVariant"
                        type="suffix"
                        name="suffix"
                        label="Minor Suffix"
                        autocomplete="off"
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="applicationInfo.product.primaryInsured.person.emailAddress"
                        :variant="inputVariant"
                        type="email"
                        name="email"
                        label="Your Email"
                        autocomplete="off"
                        :rules="emailRules"
                        required
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        :value="phoneNumber"
                        :variant="inputVariant"
                        name="phone"
                        label="Your Phone Number"
                        autocomplete="off"
                        :rules="phoneNumberRules"
                        hide-details="auto"
                        v-maska:phoneNumber.unmasked="phoneMaskOptions"
                        inputmode="numeric"
                        pattern="[0-9]*"
                      />
                    </v-col>
                  </v-row>
                  
                </div>
              </v-expand-transition>

              <v-expand-transition>
                <v-row v-if="!isChild">
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="quotePayload.issueStateAbbreviation"
                      ref="issueStateAbbreviation"
                      :items="states"
                      :variant="inputVariant"
                      :rules="requiredRules"
                      :loading="statesPending"
                      bg-color="white"
                      item-title="name"
                      item-value="code"
                      label="Your Resident State"
                      autocomplete="off"
                      hide-details="auto"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="quotePayload.primaryInsured.person.age"
                      :variant="inputVariant"
                      :rules="ageRules"
                      bg-color="white"
                      type="number"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      name="age"
                      label="Your Age"
                      autocomplete="off"
                      hide-details="auto"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="applicationInfo.product.primaryInsured.person.name.first"
                      :variant="inputVariant"
                      type="firstName"
                      name="firstName"
                      label="Your First Name"
                      autocomplete="off"
                      :rules="requiredRules"
                      required
                      hide-details="auto"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="applicationInfo.product.primaryInsured.person.name.last"
                      :variant="inputVariant"
                      type="lastName"
                      name="lastName"
                      label="Your Last Name"
                      autocomplete="off"
                      :rules="requiredRules"
                      required
                      hide-details="auto"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="applicationInfo.product.primaryInsured.person.name.suffix"
                      :variant="inputVariant"
                      type="suffix"
                      name="suffix"
                      label="Your Suffix"
                      autocomplete="off"
                      hide-details="auto"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="applicationInfo.product.primaryInsured.person.emailAddress"
                      :variant="inputVariant"
                      type="email"
                      name="email"
                      label="Your Email"
                      autocomplete="off"
                      :rules="emailRules"
                      required
                      hide-details="auto"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :value="phoneNumber"
                      :variant="inputVariant"
                      name="phone"
                      label="Your Phone Number"
                      autocomplete="off"
                      :rules="phoneNumberRules"
                      hide-details="auto"
                      v-maska:phoneNumber.unmasked="phoneMaskOptions"
                      inputmode="numeric"
                      pattern="[0-9]*"
                    />
                  </v-col>
                </v-row>
              </v-expand-transition>
              <v-row>
                <v-col cols="12">
                  <div class="text-justify text-caption">
                    <template v-if="isHilltopInstance">
                      <div v-html="quoteContactConsent"></div>
                    </template>
                    <template v-else>
                      <v-container fluid class="ma-0 pa-0">
                        <v-checkbox v-model="consentCheckbox">
                          <template v-slot:label>
                            <div>
                              I agree to the 
                              <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                  <a
                                    href="#"
                                    variant="text"
                                    v-bind="props"
                                    @click.stop.prevent="termsDialog = true"
                                    style="text-decoration: underline;"
                                  >
                                    Terms of Service.
                                </a>
                                </template>
                                Open
                              </v-tooltip>
                            </div>
                          </template>
                        </v-checkbox>
                      </v-container>
                    </template>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider class="mb-0"/>
          <v-card-actions v-if="isSecondaryAction" class="d-flex justify-end my-1">
            <v-btn
              variant="flat"
              size="large"
              light
              @click="submitForm"
              color="secondary"
            >
            {{ actionTitle }}
            </v-btn>
          </v-card-actions>
          <v-card-actions v-else class="d-flex justify-end color--white my-1">
            <v-btn
              variant="flat"
              size="large"
              light
              @click="submitForm"
            >
            {{ actionTitle }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-container>
    <v-dialog
      v-model="termsDialog"
      max-width="600"
      persistent
    >
      <v-card>
        <v-toolbar title="Terms of Service">
          <v-toolbar-items>
            <v-btn
              icon="mdi-close"
              @click="termsDialog = false"
            ></v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          By providing your information, you agree that a representative of <a href="https://emerge.me" target="_blank">emerge.me</a> may follow up on your quote request at the phone or email address provided, regardless of whether you are on any Federal or State DNC ("Do Not Call") and/or DNE ("Do Not Email") list or registry. You also acknowledge that you are over 18 years of age.
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script lang="ts">
import eventBus from '~/utils/eventBus'
import { useDisplay } from 'vuetify'
export default defineComponent({
  name: "ComponentsFormsQuoteStart",
  props: {
    heroView: {
      type: Boolean as () => boolean,
      default: () => false
    },
    showFormTitle: {
      type: Boolean as () => boolean,
      default: () => true
    },
    formTitle: {
      type: String as () => string,
      default: () => "Let's Get Started",
    },
    formSubtitle: {
      type: String as () => string,
      default: () => undefined,
    },
    stepId: {
      type: String as () => string,
      default: () => "STEP01",
    },
    actionTitle: {
      type: String as () => string,
      default: () => "Continue",
    },
    inputVariant: {
      type: String as () => "outlined" | "plain" | "underlined" | "filled" | "solo" | "solo-inverted" | "solo-filled" | undefined,
      default: () => "outlined",

    },
    isSecondaryAction: {
      type: Boolean as () => boolean,
      default: () => false
    }
  },
  setup(props: any) {
    const { stepId } = props
    const config = useRuntimeConfig()
    const states = ref<State[] | []>([])
    const statesPending = ref<boolean>(false)
    const isHilltopInstance = config.public.instanceName === 'hilltop'
    const termsDialog = ref(false)
    async function getApprovedStates() {
      statesPending.value = true
      try {
        const response = await fetch(`/webapi/approved-states`, {
          method: 'GET',
        })
        if (response.ok) {
          const newValue = await response.json()
          states.value = newValue || []
        } else {
          states.value = []
        }

      } catch (error: any) {
        states.value = []
      } finally {
        statesPending.value = false
      }
    }
    getApprovedStates()
    const quotePayload = ref<QuotePayload>(useQuotePayload().quotePayload.value);
    const quotePayloadStore = storeToRefs(useQuotePayloadStore()).quotePayload.value;
    if(!_isEmpty(quotePayloadStore)) {
      quotePayload.value = quotePayloadStore;
    }

    const policyHolderType = ref("adult")
    const isChild = computed(() => policyHolderType.value === "minor")
    const consentCheckbox = ref(false);
    const phoneNumber = ref("");
    const phoneMaskOptions = {mask: '(###) ###-####'};
    const applicationInfo = ref<ApplicationInfo>(useApplicationInfo().applicationInfo.value)
    const applicationInfoStore = storeToRefs(useApplicationInfoStore()).applicationInfo.value
    if(!_isEmpty(applicationInfoStore)) {
      applicationInfo.value = applicationInfoStore
    }
    phoneNumber.value = `${applicationInfo.value.product.primaryInsured.phone.areaCode}${applicationInfo.value.product.primaryInsured.phone.number}`

    const requiredRules = [
      (value: any) => {
        if (value && value.trim().length > 0) return true
        return 'Required.'
      },
    ]

    const emailRules = [
      (value: any) => {
        if (value) return true
        return 'Required.'
      },
      (value: any) => {
        if (validateEmail(value)) return true
        return 'Invalid Email Address.'
      }
    ]

    const phoneNumberRules = [
      (value: any) => {
        if (value) return true
        return 'Required.'
      },
      (value: any) => {
        if (validatePhoneNumber(value)) return true
        return 'Invalid Phone Number.'
      }
    ]

    
    const policyMinAge = parseInt(config.public.policyMinAge)
    const policyMaxAge = parseInt(config.public.policyMaxAge)
    const ageRules = [
      (value: any) => {
        if (value) return true
        return 'Required.'
      }, 
      (value: any) => {
        if (value >= policyMinAge) return true
        return `Age should not be less than ${policyMinAge}`
      },
      (value: any) => {
        if (value <= policyMaxAge) return true
        return `Age should not be greater than ${policyMaxAge}`
      }
    ]

    const policyMinAgeMinor = 0
    const policyMaxAgeMinor = 17
    const ageRulesMinor = [
      (value: any) => {
        if (value) return true
        return 'Required.'
      }, 
      (value: any) => {
        if (value >= policyMinAgeMinor) return true
        return `Age should not be less than ${policyMinAgeMinor}`
      },
      (value: any) => {
        if (value <= policyMaxAgeMinor) return true
        return `Age should not be greater than ${policyMaxAgeMinor}`
      }
    ]

    const issueStateAbbreviation = ref();
    const focusFirstField = () => {
      issueStateAbbreviation.value?.focus()
    }
    onMounted(() => {
      eventBus.on('focusQuoteFormFirstField', focusFirstField)
    })

    onBeforeUnmount(() => {
      eventBus.off('focusQuoteFormFirstField', focusFirstField)
    })

    const requestForm = ref();
    const submitForm = async () => {
      const { valid } = await _get(requestForm, "value", "").validate()
      if(valid) { 
        useQuotePayloadStore().setQuotePayloadValue(quotePayload.value)

        setDeepValue(applicationInfo.value, 'product.primaryInsured.phone.areaCode', phoneNumber.value.slice(0, 3))
        setDeepValue(applicationInfo.value, 'product.primaryInsured.phone.number', phoneNumber.value.slice(3))
        setDeepValue(applicationInfo.value, 'product.issueStateAbbreviation', quotePayload.value.issueStateAbbreviation)
        useApplicationInfoStore().setApplicationInfoValue(applicationInfo.value)

        const contactInfo = ref<ContactInfo>(useContactInfo().contactInfo.value)
        const email = ref(<string>_get(applicationInfo.value, "product.primaryInsured.person.emailAddress", ""))
        if(isChild.value) {
          try {
            email.value = appendPrimaryToEmail(email.value)
          } catch (error) {
            email.value = _get(applicationInfo.value, "product.primaryInsured.person.emailAddress", "");
            console.warn("Error appending primary to email: ", error)
          }
          
        }
        contactInfo.value = {
          properties: {
            email: email.value,
            firstname: _get(applicationInfo.value, "product.primaryInsured.person.name.first", ""),
            lastname: _get(applicationInfo.value, "product.primaryInsured.person.name.last", ""),
            suffix: _get(applicationInfo.value, "product.primaryInsured.person.name.suffix", ""),
            last_step_in_assurity: stepId,
            assurity_case_id: _get(applicationInfo.value, "caseId", ""),
            instance: config.public.instanceName,
            assurity_policy_number: "",
            phone: phoneNumber.value,
            age: _get(quotePayload.value, "primaryInsured.person.age", undefined),
            state: _get(quotePayload.value, "issueStateAbbreviation", ""),
          }
        };
        if(!isHilltopInstance) {
          setDeepValue(contactInfo.value, 'properties.terms_of_service_opt_in', consentCheckbox.value ? "true" : "false")
        }        
        useContactInfoStore().setContactInfoValue(contactInfo.value)

        try{
          await useContactInfo().postContactInfo(stepId)
        } catch (error) {
          console.warn("postContactInfo-error: ", error)
          const email = _get(contactInfo.value, "properties.email", "")
          try{
            const hsContactInfo = await useContactInfo().getContactInfo(email)
            const contactInfoId = _get(hsContactInfo, "id")
            if(contactInfoId) {
              setDeepValue(contactInfo.value, 'id', contactInfoId)
              useContactInfoStore().setContactInfoValue(contactInfo.value)
              try{
                await useContactInfo().putContactInfo(stepId)
              } catch(err) {
                console.warn("updateContactInfo-error: ", err)
              }
            }
          } catch(err) {
            console.warn("getContactInfo-error: ", err)
          }
        } 
        if (isChild.value) {
          type ApplicationValue = "Individual" | "IndividualSpouse" | "IndividualChild" | "Family" | null | undefined;
          let value: string = "Individual";
          let baseCoverage = quotePayload.value.primaryInsured.coverages.find((coverage: Coverage) => coverage.coverageLookup === "Base");
          if(baseCoverage) {
            setDeepValue(baseCoverage, 'options.insuredOption.applicationValue', value as ApplicationValue);
          }
          
          setDeepValue(contactInfo.value, 'properties.coverage_choice', useQuotePayloadStore().insuredOptionApplicationValue)
          useContactInfoStore().setContactInfoValue(contactInfo.value)

          return navigateTo({ path: "/forms/quote/review" });
        } else {
          return navigateTo({ path: '/forms/quote/tiers' });
        }
        
      }
    }
    const quoteContactConsent = _get(useRuntimeConfig().public, 'quoteContactConsent', '')
    const display = ref(useDisplay())
    const maxWidth = computed(() => {
      if (display.value.lgAndUp) {
        return 600
      }
      return undefined
    })
    return {
      policyHolderType, 
      isChild,
      states, 
      statesPending, 
      requestForm, 
      issueStateAbbreviation,
      requiredRules, 
      emailRules,
      phoneNumberRules,
      ageRules,
      ageRulesMinor,
      submitForm, 
      quotePayload,
      applicationInfo, 
      phoneMaskOptions, 
      phoneNumber,
      consentCheckbox,
      quoteContactConsent,
      maxWidth,
      isHilltopInstance,
      termsDialog
    };
  },
});
</script>
